import styled from "styled-components";
import { Box } from "@mui/material";

export const DataGridBox = styled(Box)`
  font-family: "Noto Sans", sans-serif;
 // width: 100%;
  height: auto;
  div {
    border-radius: 0px !important;
  }
  .MuiDataGrid-columnHeader{
    height :100px !important
  }
  .MuiDataGrid-columnHeaders{
    line-height: 18px !important;
    height : 80px !important;
    max-height: 80px !important;
  }
  .MuiDataGrid-columnHeaderTitle {
    text-overflow: unset;
    white-space: normal;
  }
  .grid-header {
    background-color: rgb(27, 74, 131);
    border-radius: 0px !important;
    color: #ffff !important;
  }
  .MuiDataGrid-cell--editing: {
    background-color: rgb(255,215,115, 0.19);
    color: #1a3e72;
        .MuiInputBase-root: {
      height: 100%;
    }
  }
  .MuiDataGrid-cell{
    white-space:unset !important;
    min-height: 55px!important;
    }
  .MuiDataGrid-selectedRowCount{
    visibility: hidden; 
    width: auto;
    height: auto;
}
.MuiDataGrid-virtualScroller {
 
    overflow: unset !importanant;
}
.MuiDataGrid-overlayWrapper{
  position:relative !important;
  height:45px !important
}
}
  .Mui-error: {
    backgroundColor: rgb(126,10,15, 0.1);
    color: red;
  }
  div {
    border-radius: 0px !important;
    .Mui-error: {
        backgroundColor: rgb(126,10,15, 0.1);
        color: red;
      }
  }
  .grid-header {
    background-color: rgb(27, 74, 131);
    border-radius: 0px !important;
    color: black;
  }
  .grid-cell {
    border-radius: 0px !important;
    .Mui-error: {
        backgroundColor: rgb(126,10,15, 0.1);
        color: red;
      }
  }
  .css-rtrcn9-MuiTablePagination-root .MuiTablePagination-selectLabel {
    display: none;
}
.css-rtrcn9-MuiTablePagination-root .MuiTablePagination-input {
  display: none;
}
.css-levciy-MuiTablePagination-displayedRows {
  display: none;
}
  .css-ptkaw2-MuiDataGrid-root .MuiDataGrid-menuIcon {
    width: auto;
    visibility: visible;
    opacity: 1 !important;
    svg {
      color: #ffff;
      visibility: visible;
      opacity: 1;
    }
  }
  .css-ptkaw2-MuiDataGrid-root .MuiDataGrid-sortIcon,
  .css-ptkaw2-MuiDataGrid-root .MuiDataGrid-filterIcon {
    font-size: inherit;
    color: #ffff;
    visibility: visible;
    opacity: 1;
  }
  .custom-row-class {
    height: 60px; /* Adjust the height as per your requirement */
  }
  .css-ptkaw2-MuiDataGrid-root
    .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted)
    .MuiDataGrid-sortIcon {
    color: #ffff;
    visibility: visible;
    opacity: 1;
  }
  svg {
    color: black;
    visibility: visible;
    opacity: 1;
  }
`;
